<template lang="pug">
div
  v-row(align="stretch")
    v-col(md="9")
      v-card
        v-card-title Company highlights
        v-card-text
          v-row(v-for="(com, i) in comp", :key="i")
            v-col(md="4")
              span
                b {{ com.label }}
            v-col(md="5", offset-md="1")
              .d-flex.align-center
                .status(:class="com.status")
                span.ml-4 {{ com.val }}

    v-col(md="3")
      v-card(style="height: 100%")
        v-card-title Case progress
        v-card-text
          .mt-4
            h1.yellow--text.text-center.display-1 45%
            v-row
              v-col(md="10")
                span Document
              v-col(md="2")
                span.yellow--text 75%
            v-row
              v-col(md="10")
                span Cover letter
              v-col(md="2")
                span.red--text 0%
            v-row
              v-col(md="10")
                span Home Office application
              v-col(md="2")
                span.red--text 0%

  v-row(align="stretch")
    v-col(md="9")
      v-card
        v-card-title Case highlights
        v-card-text 
          v-row(v-for="(com, i) in caseq", :key="i")
            v-col(md="4")
              span
                b {{ com.label }}
            v-col(md="5", offset-md="1")
              .d-flex.align-center
                .status(:class="com.status")
                span.ml-4 {{ com.val }}

    v-col(md="3")
      v-card(style="height: 100%")
        v-card-title Risk profile
        v-card-text
          .mt-4
            h1.green--text.text-center.display-1 97%
            v-row
              v-col(md="10")
                span Usage of different trading name
              v-col(md="2")
                span.yellow--text 1%
            v-row
              v-col(md="10")
                span Companies premises
              v-col(md="2")
                span.yellow--text 1%
            v-row
              v-col(md="10")
                span Authorising Officer UK Immigration status
              v-col(md="2")
                span.yellow--text 1%

  v-row.pa-4
    h2 Required documents
    v-expansion-panels.mt-4(v-model="panel", flat, focusable)
      Doc(v-for="(doc, i) in requiredDocs", :key="i", :data="doc", lawyer)
    h2.mt-4 Additional documents
    v-expansion-panels.mt-4(v-model="panel", flat, focusable)
      Doc(v-for="(doc, i) in notRequiredDocs", :key="i", :data="doc", lawyer)
</template>

<script>
import Doc from "@/components/Cases/Sponsorship/views/Documents/Docs/index.vue";

export default {
  name: "lawyer-sponsorship-overview",

  components: {
    Doc,
  },

  props: {
    docs: {
      type: Array,
    },
  },

  data() {
    return {
      comp: [
        {
          label: "Company type",
          status: "green",
          val: "Limited",
        },

        {
          label: "Company selected type",
          status: "green",
          val: "Private Limited Company",
        },

        {
          label: "Period of trading",
          status: "green",
          val: "Over 12 to 18 months",
        },

        {
          label: "Company sector",
          status: "green",
          val: "Information and Communications",
        },

        {
          label: "Number of employees",
          status: "green",
          val: "8",
        },

        {
          label: "Usage of different trading name",
          status: "orange",
          val: "Yes",
        },

        {
          label: "Companies premises",
          status: "orange",
          val: "Virtual business model",
        },
      ],
      caseq: [
        {
          label: "Previous applications in the last 12 months",
          status: "green",
          val: "No",
        },

        {
          label: "Type of body",
          status: "green",
          val: "Head Office",
        },

        {
          label: "Number of CoS",
          status: "green",
          val: "1",
        },

        {
          label: "CoS job titles",
          status: "green",
          val: "Software Engineer",
        },

        {
          label: "On Shortage Occupation list",
          status: "green",
          val: "Yes",
        },

        {
          label: "Employee Immigration status",
          status: "green",
          val: "Tier 2 General",
        },

        {
          label: "Authorising Officer UK Immigration status",
          status: "orange",
          val: "Tier 1 Exeptional talent",
        },
      ],
    };
  },

  computed: {
    documents() {
      return this.docs ? this.docs : [];
    },

    requiredDocs() {
      return this.documents.filter((d) => d.document_template.is_required);
    },

    notRequiredDocs() {
      return this.documents.filter((d) => !d.document_template.is_required);
    },
  },
};
</script>

<style lang="sass" scoped>
.status
  width: 15px
  height: 15px
  border-radius: 50%
</style>